export default __webpack_public_path__ + "static/media/img_21.811eb5bd.webp";